import { createStore } from 'vuex';
import { TLanguageCode } from '@/includes/definitions/word.d';

const ROOT_LANGUAGE_KEY = 'wordbook.rootLanguage';
const TRANSLATION_LANGUAGE_KEY = 'wordbook.translationLanguage';

export interface State {
  rootLanguage: TLanguageCode;
  translationLanguage: TLanguageCode;
}

export default createStore<State>({
  state: {
    rootLanguage: (localStorage.getItem(ROOT_LANGUAGE_KEY) as TLanguageCode) || 'en',
    translationLanguage: (localStorage.getItem(TRANSLATION_LANGUAGE_KEY) as TLanguageCode) || 'de',
  },
  getters: {
  },
  mutations: {
    setRootLanguage(state, code: TLanguageCode) {
      state.rootLanguage = code;
      localStorage.setItem(ROOT_LANGUAGE_KEY, code);
    },
    setTranslationLanguage(state, code: TLanguageCode) {
      state.translationLanguage = code;
      localStorage.setItem(TRANSLATION_LANGUAGE_KEY, code);
    },
  },
  actions: {
  },
  modules: {
  },
});
